/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/nfc.config.json";
import _ from "lodash";

const parse = require("url-parse");

export interface INFCServiceMethods extends IPluginMethodMap {
  isValidNFCRead(args: any): Promise<any>;
}

export class NFCService implements IAgentPlugin {
  readonly methods: INFCServiceMethods;

  constructor() {
    this.methods = {
      isValidNFCRead: this.isValidNFCRead.bind(this),
    };
  }

  async isValidNFCRead(args: any) {
    const url = parse(window.location.href, true);
    if (url?.query?.tag) {
      const parsed = url.query;
      if (parsed?.uid) {
        if (!parsed?.tag) {
          return false;
        }
        const tag: string = parsed.tag;
        const found = _.find(config.validCredentials, { tag: tag });
        if (found) {
          return !!found?.nfcUIDs?.includes(parsed.uid);
        }
        return false;
      }
      return true;
    }
    return false;
  }
}
